module.exports = __webpack_public_path__ + "assets/sentinel.51b1eedb.svg";